import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import Categories from '../components/Categories';
import ProductCard from '../components/ProductCard';
import API from '../utils/api';
import { FiTrendingUp, FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeaturedProducts();
  }, []);

  const fetchFeaturedProducts = async () => {
    try {
      const { data } = await API.get('/products/featured');
      setFeaturedProducts(data.products);
    } catch (error) {
      console.error('Error fetching featured products:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFF9D4]">
      <Hero />
      <Categories />

      {/* Featured Products Section */}
      <div className="py-16 bg-[#FFF9D4]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-12">
            <div>
              <div className="flex items-center space-x-2 mb-2">
                <FiTrendingUp className="text-[#F27D16] text-2xl" />
                <h2 className="section-title">
                  Featured Rentals
                </h2>
              </div>
              <p className="section-subtitle">
                Most popular items this week
              </p>
            </div>
            <Link
              to="/products"
              className="hidden md:flex items-center space-x-2 text-[#F27D16] hover:text-[#D96D0E] font-medium group"
            >
              <span>View All</span>
              <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="card h-96 skeleton"></div>
              ))}
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
               {(featuredProducts || []).slice(0, 8).map((product) => (
  <ProductCard key={product._id} product={product} />
))}
              </div>

              <div className="mt-8 text-center md:hidden">
                <Link to="/products" className="btn-primary inline-flex items-center space-x-2">
                  <span>View All Products</span>
                  <FiArrowRight />
                </Link>
              </div>
            </>
          )}
        </div>
      </div>

      {/* How It Works Section */}
      <div className="py-16 bg-[#FFF5B8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="section-title">
              How It Works
            </h2>
            <p className="section-subtitle max-w-2xl mx-auto">
              Start renting in three simple steps
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                step: '01',
                title: 'Browse & Select',
                description: 'Explore thousands of items and find exactly what you need',
                color: 'bg-[#F27D16]',
              },
              {
                step: '02',
                title: 'Book Dates',
                description: 'Choose your rental period and submit your request',
                color: 'bg-[#FCD06B]',
              },
              {
                step: '03',
                title: 'Enjoy & Return',
                description: 'Receive your item, enjoy it, and return when done',
                color: 'bg-[#D96D0E]',
              },
            ].map((item, index) => (
              <div
                key={index}
                className="text-center stagger-item card p-8"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className={`inline-flex w-20 h-20 rounded-[12px] ${item.color} text-white items-center justify-center mb-6 shadow-hover hover:scale-110 transition-transform duration-300`}>
                  <span className="text-3xl font-bold">{item.step}</span>
                </div>
                <h3 className="text-xl font-semibold text-[#386646] mb-3">
                  {item.title}
                </h3>
                <p className="text-[rgba(45,45,45,0.7)]">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-16 bg-[#386646]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4">
            Ready to Start Renting?
          </h2>
          <p className="text-xl text-[rgba(255,255,255,0.8)] mb-8">
            Join thousands of happy renters and start saving money today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/products"
              className="bg-[#F27D16] text-white px-8 py-4 rounded-[12px] font-semibold hover:bg-[#D96D0E] hover:shadow-hover transition-all duration-300 transform hover:-translate-y-1"
            >
              Browse Products
            </Link>
            <Link
              to="/register"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-[#386646] transition-all duration-300 transform hover:-translate-y-1"
            >
              List Your Items
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
